export let LABLES = {
    FULL_NAME: "User Name",
    EMAIL: "Email",
    PHONE_NUMBER: "Phone Number",
    PASSWORD: "Current Password",
    NEW_PASSWORD: "New Password",
    CONFIRM_PASSWORD: "Confirm New Password"
};

export let NAMES = {
    [LABLES.FULL_NAME]: "fullName",
    [LABLES.EMAIL]: "email",
    [LABLES.PHONE_NUMBER]: "phoneNumber",
    [LABLES.PASSWORD]: "oldPassword",
    [LABLES.NEW_PASSWORD]: "newPassword",
    [LABLES.CONFIRM_PASSWORD]: "confirmPassword"
};

export let PLACEHOLDERS = {
    [LABLES.FULL_NAME]: "Name",
    [LABLES.EMAIL]: "Email Address",
    [LABLES.PHONE_NUMBER]: "+1 232 324352",
    [LABLES.PASSWORD]: "***********",
    [LABLES.NEW_PASSWORD]: "***********",
    [LABLES.CONFIRM_PASSWORD]: "***********"
};
